"use strict";
export class CoreAuthentication {
  constructor(form) {
    if (form) {
      this._post = form;
    }
  }
}
